<template>
    <v-bottom-sheet
        v-model="showCookieBanner"
        inset
        persistent
        hide-overlay
        no-click-animation
    >
        <v-sheet class="text-center pt-8 px-8 pb-12 cookie-msg">
            <div class="my-3 grey--text">
                Our site uses cookies. By continuing to use our site, you are agreeing to our Cookie Policy.
            </div>
            <v-btn
                class="mt-2"
                color="primary"
                depressed
                @click="acceptCookieTerms"
            >
                OK, I understand
            </v-btn>
        </v-sheet>
    </v-bottom-sheet>
</template>

<script>
import {mapGetters} from "vuex";

export default {
    name: "CookieBanner",
    data: () => ({
        cookiesMsg: true,
        drawer: null
    }),
    computed: {
        ...mapGetters('settings', ['showCookieBanner'])
    },
    methods: {
        acceptCookieTerms() {
            this.$store.commit("settings/setCookieTermsAccepted", true);
        }
    }
}
</script>

<style scoped>

</style>
